<template>
  <div>
    <div class="showinfo">交易记录</div>
    <div>
      <div id="recordPan">
        <el-scrollbar style="position: relative;height: 100%;">
          <el-table :data="scDateList" stripe style="width: 100%">
            <el-table-column
              type="index"
              :index="indexMethod"
              label="ID"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="outTradeNo" label="交易号" width="300">
            </el-table-column>
            <el-table-column label="金 额" width="100">
              <template #default="scope">
                {{ scope.row.totalPaied / 100 }} 元
              </template>
            </el-table-column>
            <el-table-column prop="payMent" label="支付方式" width="100">
              <template #default="scope">
                <div v-if="scope.row.payMent === 1">
                  微信
                </div>
                <div v-else-if="scope.row.payMent === 2">
                  支付宝
                </div>
                <div v-else-if="scope.row.payMent === 4">
                  银联
                </div>
                <div v-else>
                  其他
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="withFP"
              label="是否开发票"
              width="100"
            >
              <template #default="scope">
                <div v-if="scope.row.withFP">
                  是
                </div>
                <div v-else>
                  否
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="payDateMill" label="支付时间">
              <template #default="scope">
                {{ new Date(scope.row.payDateMill).toLocaleString() }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template #default="scope">
                <el-button
                  @click="checkOneShoppingCartFun(scope.row.scId)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <div id="pagePan">
        <el-pagination
          popper-class="shopRecordsPageComponentClass"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="1"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="sum"
        >
        </el-pagination>
      </div>
      <div>
        <el-dialog title="详细记录" v-model="dialogVisible" width="50%">
          <div>
            <el-table :data="rrDateList" style="width: 100%">
              <el-table-column prop="id" label="充值记录ID" width="180">
              </el-table-column>
              <el-table-column label="金额" width="180">
                <template #default="scope">
                  {{ scope.row.money / 100 }} 元
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template #default="scope">
                  {{ scope.row.counts }}
                  <span v-if="scope.row.costType === 1">
                    点
                  </span>
                  <span v-else>
                    月
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="数量的类型">
                <template #default="scope">
                  <span v-if="scope.row.costType === 1">
                    点卡
                  </span>
                  <span v-else>
                    年费
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
          </template>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      nowPage: 1,
      pageSize: 10,
      sum: 0,
      scDateList: null,
      rrDateList: null,
      dialogVisible: false
    }
  },
  mounted  () {
    this.flushDate()
  },
  methods: {
    indexMethod (index) {
      const curpage = this.nowPage // 单前页码，具体看组件取值
      const limitpage = this.pageSize // 每页条数，具体是组件取值
      return index + 1 + (curpage - 1) * limitpage
    },
    flushDate  () {
      const api = '/md/front/deals/showAllPurchaseHistory/allPaidShoppingCarts'
      const params = {
        nowPage: this.nowPage,
        pageSize: this.pageSize
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          const d = res
          this.scDateList = d.data.list
          this.sum = d.data.sum
        } else {
          console.log('当前网络异常')
        }
      })
    },
    checkOneShoppingCartFun  (scId) {
      // alert('查看详细记录: ID' + scId)
      const api = '/md/front/deals/showAllPurchaseHistory/chargeRecords'
      const params = {
        scId: scId
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.rrDateList = res.data
          this.dialogVisible = true
        }
      })
    },
    handleSizeChange  (newSize) {
      this.nowPage = 1
      this.pageSize = newSize
      this.flushDate()
    },
    handleCurrentChange  (cuPage) {
      if (cuPage === null || cuPage < 0) {
      } else {
        this.nowPage = cuPage
        this.flushDate()
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.showinfo {
  color: #fff;
  font-size: 25px;
  height: 60px;
  line-height: 60px;
}

#recordPan {
  height: 65vh;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

#recordPan :deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}

#pagePan :deep(.el-select-dropdown__list) {
  height: 135px;
}
#pagePan :deep(.el-pager li) {
  background-color: transparent;
  font-size: 16px;
}

#pagePan :deep(.el-pagination .btn-next),
#pagePan :deep(.el-pagination .btn-prev) {
  background-color: transparent;
}
#pagePan :deep(.el-pagination button:disabled) {
  background-color: transparent;
}
#pagePan :deep(.el-pagination) {
  color: #fff;
}
#pagePan :deep(.el-pagination__total) {
  font-weight: 500;
  color: #f5f7fa;
}
#pagePan :deep(.el-pagination__jump) {
  font-weight: 500;
  color: #fff;
}
#pagePan :deep(.el-pagination .btn-next .el-icon),
#pagePan :deep(.el-pagination .btn-prev .el-icon) {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}
#pagePan :deep(.el-pager li.active) {
  color: blue;
}
#pagePan :deep(.el-pager li.btn-quicknext),
#pagePan :deep(.el-pager li.btn-quickprev) {
  line-height: 28px;
  color: #fff;
}

#pagePan :deep(.el-input__inner) {
  background-color: transparent;
  color: #fff;
}

#pagePan :deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
</style>
